import * as yup from "yup";

export interface SigninDto {
  email: string;
  senha: string;
  repetirSenha: string;
}

export const SigninSchema = yup.object().shape({
  email: yup
    .string()
    .email("Digite um e-mail válido.")
    .required("Digite seu e-mail."),
  senha: yup
    .string()
    .required("Digite sua senha.")
    .min(8, "A senha deve ter no mínimo 8 caracteres.")
    .matches(
      /[a-z]/,
      "A senha deve conter ao menos uma letra minúscula ('a'-'z')."
    )
    .matches(
      /[!@#$%^&*(),.?":{}|<>_\-\\[\]\/+=~`';]/,
      "A senha deve conter ao menos um caractere não alfanumérico."
    )
    .matches(/\d/, "A senha deve conter ao menos um número ('0'-'9').")
    .matches(
      /[A-Z]/,
      "A senha deve conter ao menos uma letra maiúscula ('A'-'Z')."
    ),
  repetirSenha: yup
    .string()
    .required("Repita a senha.")
    .oneOf([yup.ref("senha"), ""], "As senhas devem ser iguais."),
});
